export default "__VITE_ASSET__8RJmsqwo__"